const env = {
  baseUrl: process.env.REACT_APP__BASE_URL,
};


export const DEFAULT_USERS_PER_PAGE = 50;

export default env;
